import AppointmentDetailsPage from "./AppointmentDetailsPage";

export default AppointmentDetailsPage;

export * from "./AppointmentDetailsPage";
